import type { Component } from 'vue'
import {
  Home,
  TentTree,
  BarChart,
  BookOpen,
  FileText,
  UserRoundCog,
  ChartNoAxesCombined,
  Briefcase,
  Megaphone,
  MessageSquareText,
  Users,
  Library,
  UserCheck,
  GraduationCap,
} from 'lucide-vue-next'

export interface AppLink {
  name: string
  icon: Component
  to: string
  matcher: string
}

export type ContextNavKey =
  | 'program'
  | 'curriculum'
  | 'notes'
  | 'members'
  | 'programStatuses'
  | 'jobApplications'
  | 'reports'
  | 'comments'

export interface ContextNavLink {
  name: string
  icon: Component
  to: string
  key: ContextNavKey
}

export const MY_EXPEDITIONS_MATCHER = 'manage-expeditions'
export const MY_PODS_MATCHER = 'manage-pods'

export const myExpeditionsLink: AppLink = {
  name: 'My Expeditions',
  icon: Home,
  to: '/manage?tab=expeditions',
  matcher: MY_EXPEDITIONS_MATCHER,
}

export const myPodsLink: AppLink = {
  name: 'My Pods',
  icon: Users,
  to: '/manage?tab=pod',
  matcher: MY_PODS_MATCHER,
}

export const tracksLink: AppLink = {
  name: 'Configure Tracks',
  icon: Library,
  to: '/manage/tracks',
  matcher: '/manage/tracks',
}

export const graduationLink: AppLink = {
  name: 'Graduation',
  icon: GraduationCap,
  to: '/manage/graduation',
  matcher: '/manage/graduation',
}

export const fellowLinks: AppLink[] = [
  { name: 'Dashboard', icon: Home, to: '/dashboard', matcher: '/dashboard' },
  { name: 'My Expedition', icon: TentTree, to: '/my-expedition', matcher: '/my-expedition' },
  { name: 'My Progress', icon: BarChart, to: '/my-progress', matcher: '/my-progress' },
]

export const expeditionAdminLinks: AppLink[] = [
  { name: 'Onboarding', icon: UserCheck, to: '/manage/onboarding', matcher: '/manage/onboarding' },
  { name: 'All Adventurers', icon: TentTree, to: '/manage/fellows', matcher: '/manage/fellows' },
  { name: 'Reports', icon: Megaphone, to: '/manage/reports', matcher: '/manage/reports' },
  { name: 'Internal Comments', icon: MessageSquareText, to: '/manage/internal-comments', matcher: '/manage/internal-comments' },
]

export const podAdminLinks: AppLink[] = [
  { name: 'Onboarding', icon: UserCheck, to: '/manage/onboarding', matcher: '/manage/onboarding' },
  { name: 'All Adventurers', icon: TentTree, to: '/manage/fellows', matcher: '/manage/fellows' },
  { name: 'Internal Comments', icon: MessageSquareText, to: '/manage/internal-comments', matcher: '/manage/internal-comments' },
  { name: 'Create Pod', icon: Users, to: '/manage/create-pod', matcher: '/manage/create-pod' },
]

interface ContextNavBlueprintItem {
  name: string
  icon: Component
  key: ContextNavKey
  suffix: string
}

const CONTEXT_NAV_BLUEPRINT: ContextNavBlueprintItem[] = [
  { name: 'Program', icon: TentTree, suffix: '', key: 'program' },
  { name: 'Curriculum', icon: BookOpen, suffix: '/curriculum', key: 'curriculum' },
  { name: 'Weekly Notes', icon: FileText, suffix: '/notes', key: 'notes' },
  { name: 'Manage Members', icon: UserRoundCog, suffix: '/members', key: 'members' },
  { name: 'Program Statuses', icon: ChartNoAxesCombined, suffix: '/program-statuses', key: 'programStatuses' },
  { name: 'Job Applications', icon: Briefcase, suffix: '/job-applications', key: 'jobApplications' },
  { name: 'Warnings & Reports', icon: Megaphone, suffix: '/reports', key: 'reports' },
  { name: 'Comments', icon: MessageSquareText, suffix: '/comments', key: 'comments' },
]

export function buildContextNavLinks(basePath: string): ContextNavLink[] {
  return CONTEXT_NAV_BLUEPRINT.map(({ suffix, ...rest }) => ({
    ...rest,
    to: `${basePath}${suffix}`,
  }))
}
